import { render, staticRenderFns } from "./AdministrationTelemetry.vue?vue&type=template&id=710c28a8&scoped=true&"
import script from "./AdministrationTelemetry.vue?vue&type=script&lang=ts&"
export * from "./AdministrationTelemetry.vue?vue&type=script&lang=ts&"
import style0 from "./AdministrationTelemetry.vue?vue&type=style&index=0&id=710c28a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c28a8",
  null
  
)

export default component.exports